import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-payroll-compare-card',
  templateUrl: './payroll-compare-card.component.html',
  styleUrls: ['./payroll-compare-card.component.scss']
})
export class PayrollCompareCardComponent implements OnInit {

  constructor() { }

  @Input() vm: IPayrollCompareCardViewModel;

  ngOnInit(): void {
  }

}

/**
 * 5/6/2025 ymk
 *  - 
 */

/**
 * 
 */
export interface IPayrollCompareCardViewModel {
  data?: { driverPayrollCompareData?: IPayrollComparison[] };

  workingText?: string;
  errorText?: string;
  isValid?: boolean;
}

/**
 * 
 */
export interface IPayrollComparison {
  driverId: number;
  driverCode: string;
  driverName: string;
  currentPeriod?: IPayrollDataComparison;
  lastPeriod?: IPayrollDataComparison;
  stat?: IPayrollComparisonStat;
}

/**
 * 
 */
export interface IPayrollDataComparison {
  fromDate: string;
  toDate: string;
  statementPeriods: number;
  checkPeriods: number;
  workedDays: number;
  ptoDays: number;
  tripCount: number;
  standByCount: number;
  totalGratuity: number;
  totalExpenses: number;
  grossCheckPayment: number;
  compareMonth: number;
}

export interface IPayrollComparisonStat {
  checkPeriodsStat: number;
  grossCheckPaymentStat: number;
  ptoDaysStat: number;
  standByCountStat: number;
  statementPeriodsStat: number;
  totalExpensesStat: number;
  totalGratuityStat: number;
  tripCountStat: number;
  workedDaysStat: number;
  daysPtosCountStat: number;
  tripsStandBysCountStat: number;
}
